import { option_nudge_searchTerms, optionTitle_emailNudges } from './NudgeOption.locstring.json';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { createLazyOption, LazyOption } from 'owa-options-core';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));

let NudgeOption: LazyOption = createLazyOption(
    {
        key: 'nudge',
        titleStringKey: optionTitle_emailNudges,
        searchTermsStringKey: option_nudge_searchTerms,
        isHidden: () => !isFeatureEnabled('tri-nudge'),
    },
    lazyFullModule,
    m => m.default
);
export default NudgeOption;
